export default __webpack_public_path__ + "static/media/ritesh2.869b343b.png";